import React from "react";
import { withRouter, Link } from "react-router-dom";
import { injectIntl } from "react-intl";
import { FaEdit } from "react-icons/fa";

// REDUX
import { useSelector } from "react-redux";

// COMPONENTS
import ContentContainer from "../layout/ContentContainer";
import Popover from "../popovers/Popover";
import ProgressBar from "../statistics/ProgressBar";
import BigGallery from "../gallery/BigGallery";

const Overview = ({ overviewData, readonly, match, intl }) => {
  const info = useSelector(state => state.app.info);
  const user = useSelector(state => state.user);

  const projectOverviewDataWasRedered = () => {};

  return (
    <ContentContainer
      test="overviewCon"
      contentRedered={projectOverviewDataWasRedered}
      title={overviewData.categories ? overviewData.categories.join(", ") : ""}
      alerterData={overviewData.alerts || []}
    >
      <div className="projectOverview__header">
        <span className={`projectOverview__idMarker`} id={`link-${match.params.id}`}></span>
        <h2 className="projectOverview__title" id={`title-${match.params.id}`}>
          {overviewData.code ? `${overviewData.code} - ` : ""}
          {overviewData.title}
          {!overviewData.locked && (
            <Popover msg={intl.formatMessage({ id: "edit" }) + " " + overviewData.title}>
              <Link
                to={`/ui/${user.role_selected}/edit-entry/${match.params.id}/${match.params.id}`}
                aria-label={overviewData.title}
              >
                <FaEdit className="projectOverview__title-icon" />
              </Link>
            </Popover>
          )}
        </h2>
      </div>

      {overviewData?.progress && (
        <ProgressBar
          value={overviewData.progress.value}
          text={overviewData.progress.text}
          style={{ margin: "-1em 0 0.75em" }}
          ttip={overviewData.progress.ttip}
        />
      )}

      {overviewData?.gallery?.length > 0 && (
        <BigGallery
          blockEditing={overviewData.locked}
          title={overviewData.title + (overviewData.code ? " - " + overviewData.code : "")}
          data={overviewData.gallery}
        />
      )}

      {overviewData && (
        <div>
          <div className="printHeaderData">
            <img
              src={info.apps[info.default_app].logo?.src}
              className="projectOverview__printLogo"
              alt="Company Logo"
            />
            <span className="projectOverview__titleCode">{overviewData.code}</span>
            <h2 className="projectOverview__printTitle">
              {overviewData.title}
              <hr style={{ margin: "2rem 0 3rem" }} />
            </h2>
          </div>

          <StepsOverview steps={overviewData.data} opts={{ intl, user, match, readonly }} />
        </div>
      )}
    </ContentContainer>
  );
};

const StepsOverview = ({ steps }) => (
  <div className="projectOverview">
    {Array.isArray(steps) &&
      steps.map((step, index) => (
        <div
          key={`step-${index}`}
          className="projectOverview__content"
          dangerouslySetInnerHTML={{ __html: step }}
        />
      ))}
  </div>
);

export default injectIntl(withRouter(Overview));
export { StepsOverview };
